import { alertTypes } from '../actions/_actionTypes';
import { toast } from "react-toastify";

export default function (state = {}, action) {
    switch(action.type)
    {
        case alertTypes.SUCCESS:
            notify(action.payload, 'success');
            return {
                type: 'success',
                message: action.payload
            };
        case alertTypes.ERROR:
            notify(action.payload);
            return {
                type: 'error',
                message: action.payload
            };
        case alertTypes.CLEAR:
            return {};
        default:
            return state;
    }
}

const notify = (message, level = 'error') => {
    if(message.message) {
        toast[level](message.message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    } else {
        toast[level](message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    }
}


// WEBPACK FOOTER //
// ./src/reducers/alert.reducer.js